import { LoaderFunctionArgs } from 'react-router-dom'
import { toast } from 'react-toastify'

import { userApi } from '../../services/user'
import { ProfileSchema } from './Profile.schema'
import i18n from '../../i18n'
import type { AppStore } from '../../store'

export const submitProfile =
  (store: AppStore) =>
  async ({ request }: LoaderFunctionArgs) => {
    const data = (await request.json()) as ProfileSchema

    const result = await store.dispatch(userApi.endpoints.updateCurrentUser.initiate(data))

    if ('error' in result && result.error) {
      toast.error(i18n.t('Erreur lors de la sauvegarde du profil'))
      return result
    }

    toast.success(i18n.t('Profil sauvegardé avec succès'))
    return result
  }
